import { Link } from "react-router-dom";
import { ChevronLeft, Clock } from "lucide-react";
import SEO, { breadcrumbLd } from "@/components/SEO";
import { Reveal } from "@/components/Reveal";
import { CtaBand } from "@/pages/Home";
import { SITE_URL } from "@/data/business";
import { ARTICLES } from "@/data/blog";

export default function Blog() {
  return (
    <>
      <SEO
        title="دليل الإطارات والكفرات | مقالات ونصائح — نجم الإطار الرياض"
        description="دليل عملي للعناية بإطارات سيارتك: كيف تعرف أن الكفر يحتاج تغييراً، اختيار المقاس، رموز الكفرات، TPMS، الترصيص والتعامل مع انفجار الكفر."
        path="/المدونة"
        jsonLd={[
          breadcrumbLd([{ name: "الرئيسية", path: "/" }, { name: "المدونة", path: "/المدونة" }]),
          {
            "@context": "https://schema.org",
            "@type": "Blog",
            name: "دليل الإطارات — نجم الإطار",
            inLanguage: "ar",
            blogPost: ARTICLES.map((a) => ({
              "@type": "BlogPosting",
              headline: a.title,
              url: `${SITE_URL}/المدونة/${encodeURIComponent(a.slug)}`,
            })),
          },
        ]}
      />

      <section className="relative overflow-hidden grain pt-28 pb-14 border-b border-edge">
        <div className="absolute inset-0 spotlight" />
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6">
          <span className="text-gold-soft font-bold text-sm tracking-widest">دليل الإطارات</span>
          <h1 className="font-display font-black text-white text-4xl sm:text-5xl lg:text-6xl mt-3" data-testid="blog-h1">
            مقالات ونصائح من أهل الإطارات
          </h1>
          <p className="mt-5 text-lg text-gray-300 max-w-2xl leading-relaxed">
            محتوى عملي مختصر يساعدك تفهم حالة إطاراتك وتتخذ القرار الصحيح — من فريق يتعامل مع الكفرات كل يوم في الرياض.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {ARTICLES.map((a, i) => (
            <Reveal key={a.slug} delay={(i % 3) * 0.08}>
              <Link
                to={`/المدونة/${a.slug}`}
                data-testid={`blog-card-${i}`}
                className="group flex flex-col h-full bg-panel border border-edge hover:border-gold/50 rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1.5"
              >
                <div className="aspect-[16/10] overflow-hidden">
                  <img src={a.image} alt={a.alt} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <h2 className="font-display font-bold text-white text-lg leading-snug group-hover:text-gold-soft transition-colors">{a.title}</h2>
                  <p className="text-sm text-gray-400 mt-2 leading-relaxed flex-1">{a.excerpt}</p>
                  <div className="mt-5 flex items-center justify-between">
                    <span className="flex items-center gap-1.5 text-xs text-gray-500">
                      <Clock size={13} /> {a.readTime}
                    </span>
                    <span className="inline-flex items-center gap-1 text-gold-soft text-sm font-bold">
                      اقرأ <ChevronLeft size={15} className="group-hover:-translate-x-1 transition-transform" />
                    </span>
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <CtaBand title="القراءة مفيدة — والفني أسرع" testid="blog-cta-band" />
    </>
  );
}
